<template>
  <div
    id="loader"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/images/background/background1.jpg') + ')'
    }"
  >
    <div class="lg:h-10 h-5"></div>
    <div
      v-if="dataStatructureReady"
      class="lg:w-7/12 justify-center lg:m-auto mt-10 m-6 "
    >
      <!-- fields:
      <pre>{{ fields }}</pre> -->
      <!-- id:{{ id }} -->
      <h1
        class=" p-4 text-center border border-solid border-gray-600 bg-custom-purple"
      >
        Survey Form
      </h1>
      <p class="text-center mt-3">
        Thank you for taking the time to help us improve 🙏
      </p>
      <div>
        <form>
          <component
            :is="fName.type"
            :structure="fName"
            v-for="(fName, fIndex) in fields"
            :key="fIndex"
            :index="fIndex"
            >{{ fName.type }}<br
          /></component>
        </form>
        <div class="vx-row m-6 p-5">
          <div class="vx-col w-full text-center">
            <vs-button class="mr-3 mb-2" @click="submitHandler"
              >Submit</vs-button
            >
            <vs-button color="red" type="border" class="mb-2 hover:text-white"
              >Cancle</vs-button
            >
          </div>
        </div>
      </div>
      <div>
        <!-- @input="data => updateInputParams(data)" -->
        <!-- @error="value => handleErrors(value)" -->
        <!-- :baseUrl="baseUrl" -->
        <!-- :uploadEndpoint="uploadEndpoint" -->
        <!-- :value="currentData[fIndex]" -->
      </div>
    </div>
  </div>
</template>
<script>
import aronTextbox from "../survey/formElements/textbox";
import aronPassword from "../survey/formElements/password";
import aronSelect from "../survey/formElements/select";
import aronMultiSelect from "../survey/formElements/multiselect";
import aronRadio from "../survey/formElements/radio";
import aronRadioStatic from "../survey/formElements/radioStatic";
import aronTextarea from "../survey/formElements/textArea";
import aronCurrency from "../survey/formElements/currency";
import aronNumber from "../survey/formElements/number";
import aronInteger from "../survey/formElements/integer";
import aronDate from "../survey/formElements/date";
import aronYearOnly from "../survey/formElements/yearOnly";
import aronFile from "../survey/formElements/file";
import aronCheckbox from "../survey/formElements/checkbox";
import aronTime from "../survey/formElements/time";
//mixin
import { alertMixin } from "@/mixin/alertMixin";
import { axiosMixin } from "@/mixin/axiosMixin";
import { helperMixin } from "@/mixin/helperMixin";

export default {
  components: {
    aronTextbox,
    aronPassword,
    aronSelect,
    aronMultiSelect,
    aronRadio,
    aronRadioStatic,
    aronTextarea,
    aronCurrency,
    aronNumber,
    aronInteger,
    aronDate,
    aronYearOnly,
    aronFile,
    aronCheckbox,
    aronTime
  },
  mixins: [alertMixin, axiosMixin, helperMixin],
  data() {
    return {
      id: this.$route.params.id,
      fields: [],
      dataStatructureReady: false
    };
  },
  // computed: {
  //   // aaa
  // },
  methods: {
    getData(from) {
      this.startLoading();
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;
      // console.log("filterssssssss:", this.filter);
      // if (this.countObject(this.filter) > 0) {
      //   console.log("filterEndpoint:", this.filterEndpoint);
      //   this.aronPost(this.filterEndpoint, this.filter, params, sort)
      //     .then(response => {
      //       if (response.status == 200) {
      //         this.tblData = response.data.data;
      //         this.dataStructure = response.data.fields;

      //         this.setDataStructure();
      //         this.dataStatructureReady = true;

      //         this.totalData = response.data.meta.pagination.total;
      //         this.pageTotal = response.data.meta.pagination.total_pages;
      //       }

      //       this.closeLoading();
      //     })
      //     .catch(error => {
      //       // this.decodeErrorFromAxios(error);
      //       this.closeLoading();
      //     });
      // } else { }
      this.aronPost("survey", this.id, params, sort)
        .then(response => {
          console.log("response : ", response);
          this.fields = response.data.data.fields;
          // this.tblData = response.data.data;
          // this.dataStructure = response.data.fields;

          // this.setDataStructure();
          this.dataStatructureReady = true;

          // this.pageTotal = response.data.meta.pagination.total_pages;
          // this.totalData = response.data.meta.pagination.total;

          this.closeLoading();
        })
        .catch(error => {
          this.decodeErrorFromAxios(error);
          this.closeLoading();
        });
    },
    startLoading() {
      this.$vs.loading({
        container: "#loader",
        scale: 0.6
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader > .con-vs-loading");
    },
    submitHandler() {
      this.$router.replace("/submitted");
    }
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
    }
  },
  created() {
    this.dataStatructureReady = false;
  },
  mounted() {
    this.getData();
    this.isMounted = true;
    this.startLoading();
  }
};
</script>
<style scoped>
body {
  background-color: #c0bbf2;
}
</style>
